import axios from 'axios';

export default class SettingsService
{
    public static async fetch(key: string)
    {
        return (await axios.get<Record<string, any>>(`admin/settings/${key}`)).data;
    }

    public static async fetchMonitoring()
    {
        return (await axios.get<MonitoringFormModel>(`admin/settings/monitoring`)).data;
    }

    public static async save(key: string, model: Record<string, any>)
    {
        return (await axios.post<Statement>(`admin/settings/${key}`, model)).data;
    }

    public static async saveMonitoring(model: MonitoringFormModel)
    {
        return (await axios.post<Statement>(`admin/settings/monitoring`, model)).data;
    }

    public static async restartApplication()
    {
        return (await axios.post<Statement>(`admin/settings/restart-application`)).data;
    }
}

export interface MonitoringFormModel
{
    appInsights: AppInsightsOptions;
    openTelemetry: OpenTelemetryOptions;
    grafanaLoki: GrafanaLokiOptions;
    sentry: SentryOptions;
}

export interface AppInsightsOptions
{
    enabled: boolean;
    connectionString: string;
    tracingEnabled: boolean;
    adaptiveSamplingEnabled: boolean;
    excludedDependencies: AppInsightsDependencyType[];
    httpDependencyTracking: AppInsightsHttpDependencyType;
    httpDependencyUrls: string;
}

export interface OpenTelemetryOptions
{
    enabled: boolean;
    uri: string;
    login: string;
    password: string;
    serviceName: string;
    serviceNamespace: string;
    netRuntimeEnabled: boolean;
    httpMonitoringEnabled: boolean;
    entityFrameworkCoreEnabled: boolean;
}

export interface GrafanaLokiOptions
{
    enabled: boolean;
    ['serilog:WriteTo:Async:Args:configure:Loki:Args:configureLogger:WriteTo:Loki:Args:uri']: string;
    ['serilog:WriteTo:Async:Args:configure:Loki:Args:configureLogger:WriteTo:Loki:Args:credentials:login']: string;
    ['serilog:WriteTo:Async:Args:configure:Loki:Args:configureLogger:WriteTo:Loki:Args:credentials:password']: string;
}

export interface SentryOptions
{
    enabled: boolean;
    dsn: string;
    profilingEnabled: boolean;
    sendDefaultPii: boolean;
    attachStackTrace: boolean;
    tracingEnabled: boolean;
    tracesSampleRate: number;
    profilesSampleRate: number;
}

enum AppInsightsDependencyType
{
    Sql = 1,
    Redis = 2,
    ElasticSearch = 3,
    AzureBlob = 4
}

const AppInsightsDependencyTypeOptions = (): Option<AppInsightsDependencyType>[] => ([
    { value: AppInsightsDependencyType.Sql, text: 'SQL' },
    { value: AppInsightsDependencyType.Redis, text: 'Redis' },
    { value: AppInsightsDependencyType.ElasticSearch, text: 'ElasticSearch' },
    { value: AppInsightsDependencyType.AzureBlob, text: 'Azure blob' }

]);

enum AppInsightsHttpDependencyType
{
    All = 0,
    Off = 1,
    IncludeSelected = 2,
    ExcludeSelected = 3
}

const AppInsightsHttpDependencyTypeOptions = (): Option<AppInsightsHttpDependencyType>[] => ([
    { value: AppInsightsHttpDependencyType.All, text: $t('[[[Wszystkie]]]') },
    { value: AppInsightsHttpDependencyType.Off, text: $t('[[[Wyłaczone]]]') },
    { value: AppInsightsHttpDependencyType.IncludeSelected, text: $t('[[[Loguj wybrane]]]') },
    { value: AppInsightsHttpDependencyType.ExcludeSelected, text: $t('[[[Nie loguj wybranych]]]') }
]);

export {
    AppInsightsDependencyType,
    AppInsightsDependencyTypeOptions,
    AppInsightsHttpDependencyType,
    AppInsightsHttpDependencyTypeOptions
};
